import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Transaction } from '../shared/models/transactions/transaction';
import { TransactionDataBundle } from '../shared/models/transactions/transaction-data-bundle';
import { SearchRequest } from '../shared/models/general/search-request';
import { NewTransaction } from '../shared/models/transactions/new-transaction';
import { TransactionSearchRequest } from '../shared/models/transactions/transaction-search-request';
import { SavedTradesResponse } from '../shared/models/transactions/saved-trades-response';
import { BadTransactionCount } from '../shared/models/transactions/bad-transaction-count';
import { TransactionFiaSdaEditData } from '../shared/models/transactions/transaction-fia-sda-edit-data';
import { UpdateTransactionSdaPinRequest } from '../shared/models/transactions/update-transaction-sda-pin-request';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/transactions/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public GetAvailableBalances(ArbFacilitatorId: number): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + 'availablebalance/' + ArbFacilitatorId, {
        observe: 'response',
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return res.body;
            }
          }
        })
      );
  }

  public SearchTransactions(model: TransactionSearchRequest): Observable<any> {
    return this.http
      .post<Transaction[]>(this.apiUrl + 'search', model, {
        observe: 'response',
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return res.body.map((data: any) => new Transaction().deserialize(data));
            }
          }
        })
      );
  }

  public GetTransactionDataBundleForEntity(SearchRequest: SearchRequest): Observable<TransactionDataBundle[]> {
    return this.http
      .post<TransactionDataBundle[]>(this.apiUrl + 'databundle', SearchRequest)
      .pipe(map((res) => res.map((res) => new TransactionDataBundle().deserialize(res))));
  }

  public NewTransactions(transactions: NewTransaction[]): Observable<SavedTradesResponse> {
    return this.http.post<SavedTradesResponse>(this.apiUrl, transactions);
  }

  public UpdateTransaction(transaction: Transaction): Observable<any> {
    return this.http.put<Transaction>(this.apiUrl, transaction, { observe: 'response' }).pipe(
      map((res) => {
        if (res) {
          if (res.status == 200) {
            return new Transaction().deserialize(res.body);
          }
        }
      })
    );
  }

  public UpdateSdaPinAllocation(transactionId: number, model: UpdateTransactionSdaPinRequest): Observable<Transaction> {
    return this.http.put<TransactionFiaSdaEditData>(`${this.apiUrl}${transactionId}/sda-pin-allocation`, model).pipe(
      map((res) => {
        res.transaction.transactionUserFiaPins = res.currentlyAssignedPins;
        return res.transaction;
      })
    );
  }

  public GetTransactionById(transactionId: number): Observable<Transaction> {
    return this.http.get<Transaction>(`${this.apiUrl}${transactionId}`);
  }

  public GetTransactionFiaSdaEditData(transactionId: number): Observable<TransactionFiaSdaEditData> {
    return this.http.get<TransactionFiaSdaEditData>(`${this.apiUrl}${transactionId}/sda-pin-edit-data`);
  }

  public RefreshDooyaStatus(transactionId: number): Observable<Transaction> {
    return this.http.post<Transaction>(this.apiUrl + `refresh-dooya-status/${transactionId}`, {});
  }

  public FindBadTransactions(): Observable<BadTransactionCount[]> {
    return this.http.get<BadTransactionCount[]>(this.apiUrl + `find-bad`);
  }
}
